const HisCheckCircle = ({ color, sx }) => {
  const strokeColor = color ?? "#708FBB";
  const _sx = sx ?? {};
  return (
    <svg style={_sx} viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.9743 40.0814C31.8238 40.0814 39.8079 32.0973 39.8079 22.2477C39.8079 12.3982 31.8238 4.41406 21.9743 4.41406C12.1248 4.41406 4.14062 12.3982 4.14062 22.2477C4.14062 32.0973 12.1248 40.0814 21.9743 40.0814Z"
        stroke={strokeColor}
        strokeWidth="3.26101"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.625 22.2464L20.1917 25.8132L27.3252 18.6797"
        stroke={strokeColor}
        strokeWidth="3.26101"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HisCheckCircle;
